import React from "react";
import styled from "styled-components";
import { LifeAtBodyPrimary } from "@common/LifeAtText/LifeAtText";
import Styles from "@themes/Styles";

const DiscountCodeContainer = styled.div`
    width: 100%;
    height: auto;
    border-radius: 10px;
    background-color: rgba(58, 126, 255, 0.1);
    display: flex;
    justify-content: center;
    padding: 15px;
`;

const StyledBodyPrimary = styled(LifeAtBodyPrimary)`
    text-align: center;
`;

const DiscountCodeText = styled.span`
    font-weight: bold;
    color: ${Styles.buttonFillBlue};
    text-align: center;
`;

const DISCOUNT_CODE_LABEL = "Additional 50% off yearly subscription: Use code ";
const DISCOUNT_CODE = "EDUCATIONLIFEAT";
interface StudentDiscountCodeProps {
    readonly className?: string;
}

export default function StudentDiscountCode(props: StudentDiscountCodeProps) {
    return (
        <DiscountCodeContainer>
            <StyledBodyPrimary>
                {DISCOUNT_CODE_LABEL} <DiscountCodeText>{DISCOUNT_CODE}</DiscountCodeText>
            </StyledBodyPrimary>
        </DiscountCodeContainer>
    );
}
